<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $t("view") }} {{ $t("fnbDynamicPricing") }}
      </div>
      <div>
        <a class="btn-blue" @click.prevent.stop="goToRoute"
          >{{ $t("edit") }} {{ $t("fnbDynamicPricing") }}</a
        >
        <router-link class="btn-blue" to="fnb-dynamic-pricing"
          >{{ $t("fnbDynamicPricing") }} {{ $tc("list", 2) }}</router-link
        >
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("selected") }} {{ $tc("cinema", 2) }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ selectedCinema }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t("fdpName") }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{ fdp_name }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("fdpDescription") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ fdp_description }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("fromDateTime") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ from_date_time | fulldaydateparse }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("toDateTime") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ to_date_time | fulldaydateparse }}
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-xl-2">
            <div>{{ $t("days") }}:</div>
          </div>
          <div class="col-lg-9 col-xl-10 pl-0">
            <div class="row">
              <b-form-checkbox
                v-for="(weekdaysLoop, weekdaysKey) in weekDays"
                :key="weekdaysKey"
                style="min-width: 125px"
                class="j-checkbox mb-3"
                disabled
                @change="onChangeWeekdays($event, weekdaysKey)"
                v-model="weekDays[weekdaysKey]"
              >
                <div class="text-capitalize">{{ weekdaysKey }}</div>
              </b-form-checkbox>
            </div>
          </div>

          <table class="table table-striped">
            <thead>
              <tr>
                <th>{{ $t("fnbitems") }}</th>
                <th>{{ $t("oldGrossPrice") }}</th>
                <th>{{ $t("newGrossPrice") }}</th>
                <th>{{ $t("discount") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(singleItem, itemIndex) in fnbItems" :key="itemIndex">
                <td>{{ singleItem.item_name }}</td>
                <td>{{ currFormat(singleItem.old_item_gross_price) }}</td>
                <td>{{ currFormat(singleItem.fnb_final_price) }}</td>
                <td>{{ currFormat(singleItem.difference) }}</td>
              </tr>
            </tbody>
          </table>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $tc("status", 1) }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{
                  fdp_is_active ? $t("active") : $t("not") + " " + $t("active")
                }}
              </div>
            </div>
          </div>

          <div
            v-if="GetRoleId && GetRoleId === 1"
            class="col-md-12 py-2 border-bottom"
          >
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("createdby") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span>{{ fdp_created_by }}</span>
              </div>
            </div>
          </div>

          <div
            v-if="GetRoleId && GetRoleId === 1"
            class="col-md-12 py-2 border-bottom"
          >
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("createdat") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span class="mr-3">{{ created_at | dateparse }}</span>
              </div>
            </div>
          </div>

          <div
            v-if="GetRoleId && GetRoleId === 1"
            class="col-md-12 py-2 border-bottom"
          >
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("modifiedby") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span>{{ fdp_updated_by }}</span>
              </div>
            </div>
          </div>

          <div v-if="GetRoleId && GetRoleId === 1" class="col-md-12 py-2">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("modifiedat") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span class="mr-3">{{ updated_at | dateparse }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MasterService from "@/services/MasterService";
import CinemasService from "@/services/CinemasService";
import MarketingService from "@/services/MarketingService";
import ExhibitorService from "@/services/ExhibitorService";
import moment from "moment";

export default {
  data() {
    return {
      isRoleID: true,
      fdp_is_active: true,

      fdp_common_id: null,
      fdp_is_active: true,
      fdp_name: "",
      fdp_description: "",
      from_date_time: null,
      to_date_time: null,
      cinema_id: null,
      weekDays: {
        selectAll: false,
        sunday: false,
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
      },
      fnbItems: [
        {
          fdp_id: null,
          item_id: null,
          item_name: "",
          old_item_price: 0,
          old_item_gross_price: 0,
          item_price: 0,
          difference: 0,
          fnb_tax_price: 0,
          fnb_final_price: 0,
        },
      ],
      updated_at: null,
      fdp_updated_by: null,
      created_at: null,
      fdp_created_by: null,
      selectedCinema: "",
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    this.fdp_common_id = this.$route.query.fdp_common_id;
    if (this.fdp_common_id) {
      this.getDynamicPricingDetails();
    }
    if (true) {
      this.isRoleID = false;
    }
  },
  methods: {
     getTaxAmount: function (item_id, index) {
      let payload = {
        item_id: item_id,
        cinema_id: this.cinema_id,
      };
      ExhibitorService.GetFnbTaxPrice(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.fnbItems[index].fnb_tax_price = 0;
            data.Records.map((x) => {
              console.log("x.frcs_amount :>> ", x.frcs_amount);
              this.fnbItems[index].fnb_tax_price += x.frcs_amount;
              console.log(
                "this.fnbItems[index].fnb_tax_price :>> ",
                this.fnbItems[index].fnb_tax_price
              );
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          this.$toasted.show(err);
        });
    },
    getDynamicPricingDetails: function () {
      let payload = {
        fdp_common_id: this.fdp_common_id,
      };
      ExhibitorService.GetSingleFnbDynamicPricing(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            for (var i = 0; i < data.Records.length - 1; i++) {
              this.addDay();
            }
            let obj = data.Records[0];
            Object.keys(obj).map((x) => {
              if (x === "fdp_created_by") {
                this.getViewUsersDetails(obj[x], "fdp_created_by");
              } else if (x === "fdp_updated_by") {
                this.getViewUsersDetails(obj[x], "fdp_updated_by");
              }
            });
            this.selectedCinema = obj.cine_name;
            this.cinema_id = obj.cine_id;
            this.fdp_name = obj.fdp_name;
            this.fdp_description = obj.fdp_description;
            this.from_date_time = obj.from_date_time;
            this.to_date_time = obj.to_date_time;
            this.created_at = obj.fdp_created_at;
            this.updated_at = obj.fdp_updated_at;
             data.Records.map((x, index) => {
              this.setDaysValue(x, index);
              this.getTaxAmount(x.item_id, index);
              this.fnbItems[index].fdp_id = x.fdp_id;
              this.fnbItems[index].item_id = x.item_id;
              this.fnbItems[index].old_item_price = +parseFloat(x.fp_amount).toFixed(this.MIN_FRACTION_DIGITS);
              this.fnbItems[index].old_item_gross_price = parseFloat(x.fp_total_amount).toFixed(this.MIN_FRACTION_DIGITS);
              this.fnbItems[index].item_price = +parseFloat(x.item_price).toFixed(this.MIN_FRACTION_DIGITS);
              this.fnbItems[index].difference =
                x.item_price && String(x.item_price).length > 0
                  ? parseFloat(
                      (parseFloat(x.fp_amount) - parseFloat(x.item_price)) > 0 ? (parseFloat(x.fp_amount) - parseFloat(x.item_price)) : 0
                    ).toFixed(this.MIN_FRACTION_DIGITS)
                  : 0;
              this.fnbItems[index].item_name = x.item_name;
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError).finally(() => {
          setTimeout(() => {
            this.fnbItems.map((x, index) => {
              this.fnbItems[index].fnb_final_price =
                parseFloat(parseFloat(x.fnb_tax_price) + parseFloat(x.item_price)).toFixed(this.MIN_FRACTION_DIGITS);
            });
          }, 1000);
        });
    },
    addDay: function () {
      this.fnbItems.push({
        fdp_id: null,
        item_id: null,
        item_name: "",
        old_item_price: 0,
        old_item_gross_price: 0,
        item_price: 0,
        difference: 0,
        fnb_tax_price: 0,
        fnb_final_price: 0,
      });
    },
    setDaysValue: function (activeDays, index) {
      let days = {
        sunday: "fdp_is_sunday",
        monday: "fdp_is_monday",
        tuesday: "fdp_is_tuesday",
        wednesday: "fdp_is_wednesday",
        thursday: "fdp_is_thursday",
        friday: "fdp_is_friday",
        saturday: "fdp_is_saturday",
      };
      if (activeDays) {
        Object.keys(days).map((x) => {
          this.weekDays[x] =
            activeDays[days[x]] && activeDays[days[x]] === "Y" ? true : false;
        });

        let array = Object.keys(this.weekDays).filter(
          (x) => x !== "selectAll" && !this.weekDays[x]
        );
        if (array.length === 0) {
          this.weekDays["selectAll"] = true;
        }
      }
    },
    getViewUsersDetails(user_id, fieldvalue) {
      this[fieldvalue] = "-";
      if (user_id) {
        MasterService.GetUserInfoById({ user_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this[fieldvalue] = data.Records[0].user_name;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      }
    },
    goToRoute: function () {
      this.$router.push({
        path: "/cinema-manager/edit-fnb-dynamic-pricing",
        query: {
          fdp_common_id: this.fdp_common_id,
        },
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/FnbDynamicPricing/viewFnbDynamicPricing.vue